import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import * as React from 'react';
import { addEffect, addAfterEffect } from '@react-three/fiber';
import StatsImpl from 'stats.js';
import { useEffectfulState } from '../helpers/useEffectfulState.js';

function Stats(_ref) {
  var _ref$showPanel = _ref.showPanel,
      showPanel = _ref$showPanel === void 0 ? 0 : _ref$showPanel,
      className = _ref.className,
      parent = _ref.parent;
  var stats = useEffectfulState(function () {
    return new StatsImpl();
  }, []);
  React.useEffect(function () {
    if (stats) {
      var _stats$dom$classList;

      var node = parent && parent.current || document.body;
      stats.showPanel(showPanel);
      node == null ? void 0 : node.appendChild(stats.dom);
      if (className) (_stats$dom$classList = stats.dom.classList).add.apply(_stats$dom$classList, _toConsumableArray(className.split(' ').filter(function (cls) {
        return cls;
      })));
      var begin = addEffect(function () {
        return stats.begin();
      });
      var end = addAfterEffect(function () {
        return stats.end();
      });
      return function () {
        node == null ? void 0 : node.removeChild(stats.dom);
        begin();
        end();
      };
    }
  }, [parent, stats, className, showPanel]);
  return null;
}

export { Stats };